// import React, { useState } from 'react';
// import './Login_page.css';
// import { useNavigate } from 'react-router-dom';

// function LoginForm({ setShowMessage, setMessage, setError }) {
//   const [phoneNo, setPhoneNo] = useState('');
//   const [otp, setOtp] = useState('');
//   const navigate = useNavigate();

//   const handleOTP = async(e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           "body": {
//             "action": "login",
//             "username": phoneNo,
//             "phone_number": phoneNo
//           }
//         })
//       });
//       const data = await response.json();
//       //console.log(data);
//       if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
//         setShowMessage(true);
//         setMessage("OTP Sent Successfully");
//         setError(false);
//       }else{
//         setShowMessage(true);
//         setMessage("Failed to send OTP, please try again");
//         setError(true);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   const handleSubmit = async(e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           "body": {
//             "action": "login_validate",
//             "username": phoneNo,
//             "phone_number": phoneNo,
//             "otp": otp
//           }
//         })
//       });
//       const data = await response.json();
//       //console.log(data);
//       if(data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203){
//         setShowMessage(true);
//         setMessage("Login Successfully");
//         setError(false);
//         const cleanedBody = data.body.replace(/NaN/g, "null");
//         const parsedData = JSON.parse(cleanedBody);
//         localStorage.setItem('token',JSON.stringify(parsedData.token));
//         navigate('/my-account/address');
//       }else{
//         setShowMessage(true);
//         setMessage("Login Failed Invalid Credentials");
//         setError(true);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <div className='login-page-form'>
//       <h2>Login</h2>
//       <p>Welcome back! Sign in to your account.</p>
//       <div className='login-page-form-group'>
//         <label htmlFor="phone-no">Phone No.</label>
//         <input
//           type="number"
//           id="phone-no"
//           onChange={(e) => {
//             if(e.target.value.length() === 10) {
//               setPhoneNo(e.target.value);
//             }
//           }}
//         />
//       </div>
//       <button className='login-page-form-button' disabled={(phoneNo)?false:true} onClick={handleOTP}>Send OTP</button>
//       <div className='login-page-form-group'>
//         <label htmlFor="otp">OTP</label>
//         <input
//           type="number"
//           id="otp"
//           onChange={(e) => setOtp(e.target.value)}
//         />
//       </div>
//       <button className='login-page-form-button' disabled={(otp)?false:true} onClick={handleSubmit}>Login With OTP</button>
//     </div>
//   );
// };

// export default LoginForm;

import React, { useState } from 'react';
import './Login_page.css';
import { useNavigate } from 'react-router-dom';

function LoginForm({ setShowMessage, setMessage, setError }) {
  const [phoneNo, setPhoneNo] = useState('');
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const navigate = useNavigate();
  const [phoneButtonClicked, setPhoneButtonClicked] = useState(false);
  const [otpButtonClicked, setOtpButtonClicked] = useState(false);

  // Handle phone number input with validation
  const handlePhoneChange = (e) => {
    const input = e.target.value;
    // Only allow numbers and limit to 10 digits
    if (/^\d*$/.test(input) && input.length <= 10) {
      setPhoneNo(input);
    }
  };

  // Handle OTP input
  const handleOtpChange = (e) => {
    const input = e.target.value;
    // Only allow numbers for OTP
    if (/^\d*$/.test(input)) {
      setOtp(input);
    }
  };

  const handleOTP = async(e) => {
    e.preventDefault();
    
    setPhoneButtonClicked(true);
    // Validate phone number before sending OTP
    if (phoneNo.trim().length !== 10) {
      setShowMessage(true);
      setMessage("Please enter a valid 10-digit phone number");
      setError(true);
      return;
    }

    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "login",
            "username": phoneNo,
            "phone_number": phoneNo
          }
        })
      });
      const data = await response.json();
      
      if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
        setShowMessage(true);
        setMessage("OTP Sent Successfully");
        setError(false);
        setIsOtpSent(true);
      } else {
        setShowMessage(true);
        setMessage("Failed to send OTP, please try again");
        setError(true);
      }
    } catch (error) {
      console.error(error);
      setShowMessage(true);
      setMessage("An error occurred. Please try again later.");
      setError(true);
    }
  };
  
  const handleSubmit = async(e) => {
    e.preventDefault();
    
    setOtpButtonClicked(true);

    // Validate inputs before submission
    if (phoneNo.trim().length !== 10) {
      setShowMessage(true);
      setMessage("Please enter a valid 10-digit phone number");
      setError(true);
      return;
    }

    if (!otp) {
      setShowMessage(true);
      setMessage("Please enter the OTP");
      setError(true);
      return;
    }

    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "login_validate",
            "username": phoneNo,
            "phone_number": phoneNo,
            "otp": otp
          }
        })
      });
      const data = await response.json();
      
      if(data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203){
        setShowMessage(true);
        setMessage("Login Successful");
        setError(false);
        
        // Clean NaN values in the response
        const cleanedBody = data.body.replace(/NaN/g, "null");
        const parsedData = JSON.parse(cleanedBody);
        localStorage.setItem('token', JSON.stringify(parsedData.token));
        navigate('/cart');
      } else {
        setShowMessage(true);
        setMessage("Login Failed: Invalid Credentials");
        setError(true);
      }
    } catch (error) {
      console.error(error);
      setShowMessage(true);
      setMessage("An error occurred. Please try again later.");
      setError(true);
    }
  };

  return (
    <div className='login-page-form'>
      <h2>Login</h2>
      <p>Welcome back! Sign in to your account.</p>
      
      <div className='login-page-form-group'>
        <label htmlFor="phone-no">Phone No. <span>(Sample: 1234567890)</span></label>
        <input
          type="tel"
          id="phone-no"
          value={phoneNo}
          onChange={handlePhoneChange}
          placeholder="Enter your 10-digit phone number"
          maxLength="10"
        />
        {phoneNo && phoneNo.length !== 10 && (
          <p className="error-text" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
            Phone number must be 10 digits
          </p>
        )}
      </div>
      
      <button 
        className='login-page-form-button' 
        disabled={phoneNo.length !== 10}
        onClick={handleOTP}
        style={phoneButtonClicked ? { backgroundColor: 'rgba(0, 0, 0, 0.438)' } : {}}
      >
        Send OTP
      </button>
      
      <div className='login-page-form-group'>
        <label htmlFor="otp">OTP</label>
        <input
          type="text"
          id="otp"
          value={otp}
          onChange={handleOtpChange}
          placeholder="Enter OTP"
          disabled={!isOtpSent}
        />
      </div>
      
      <button 
        className='login-page-form-button' 
        disabled={!otp || !isOtpSent}
        onClick={handleSubmit}
        style={otpButtonClicked ? { backgroundColor: 'rgba(0, 0, 0, 0.438)' } : {}}
      >
        Login With OTP
      </button>
    </div>
  );
}

export default LoginForm;